export const ALLERGIES_SHOW_LIMIT = 5;
